import getWindow from "./window";
import { logError, ERROR_TYPE } from "./newRelicLogger";

export function checkForEdgeError() {
  const stockPriceEdgeError = getWindow().asos.pdp.config.stockPriceEdgeError;
  if (stockPriceEdgeError) {
    logError(ERROR_TYPE.EdgeError, { message: stockPriceEdgeError });
  }
}
